import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 품목 사이클타임(고객>품목그룹>품목별 생산 사이클타임 크로스탭) — AnalysisController#getItemCycleTime
// (백엔드는 factoryplan/analysis/item-cycle-time). PlanResult류의 "날짜+주차/월/요일" 2단 그룹
// 피벗(Bucket.getHeader, LT-bucket flat 헤더 아님)이고, `totalAvgCycleTime`(행 전체 버킷 평균)이
// 별도 leaf 필드로 내려온다. old도 그리드 조회(loadData)/차트 드릴다운(loadChartData) 둘 다 같은
// 엔드포인트를 customerCd/itemGrpCd/itemCd 필터값만 다르게 호출한다. changes(FilterParameter)는
// 백엔드가 안 읽으므로 postParams만 쓴다(fp-report-screen-guide.md §A-6e와 동일 결정).
const getItemCycleTimes = (params) => fpApiUtil.postParams(`${ANALYSIS}/item-cycle-time`, params);

const fpItemCycleTimeService = { getItemCycleTimes };
export default fpItemCycleTimeService;
